import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useRegisterViewModel } from './view-model/register.view-model';
import { RegisterView } from './view/register.view';

export const RegisterPage = () => {
  const registerVM = useRegisterViewModel();

  return (
    <AsyncRenderer
      data={registerVM}
      renderer={RegisterView}
      loadRender={<main>Loading registration flow...</main>}
    />
  );
};
